<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz">Not of the princes and prelates with periwigged charioteers</span></p>
<p class="p4"><span class="sz">Riding triumphantly laureled to lap the fat of the years,</span></p>
<p class="p4"><span class="sz">Rather the scorned—the rejected—the men hemmed in with spears;</span></p>
<p class="p3"><span class="sz"><span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">The men in tattered battalion which fights till it dies,</span></p>
<p class="p4"><span class="sz">Dazed with the dust of the battle, the din and the cries,</span></p>
<p class="p4"><span class="sz">The men with the broken heads and the blood running into their eyes.</span></p>
<p class="p3"><span class="sz"><span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">Not the be-medalled Commander, beloved of the throne,</span></p>
<p class="p4"><span class="sz">Riding cock-horse to parade when the bugles are blown,</span></p>
<p class="p4"><span class="sz">But the lads who carried the hill and cannot be known.</span></p>
<p class="p3"><span class="sz"><span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">Others may sing of the wine and the wealth and the mirth,</span></p>
<p class="p4"><span class="sz">The portly presence of potentates goodly in girth;—</span></p>
<p class="p4"><span class="sz">Mine be the dirt and the dross, the dust and scum of the earth!</span></p>
<p class="p3"><span class="sz"><span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">Theirs be the music, the colour, the glory, the gold;</span></p>
<p class="p4"><span class="sz">Mine be a handful of ashes, a mouthful of mould.</span></p>
<p class="p4"><span class="sz">Of the maimed, of the halt and the blind in the rain and the cold—</span></p>
<p class="p3"><span class="sz"><span class="Apple-converted-space"> </span></span></p>
<p class="p4"><span class="sz">Of these shall my songs be fashioned, my tale be told. Amen.</span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz">—John Masefield</span></p>
<p class="p4"><span class="sz"><span class="Apple-converted-space"> </span>“A Consecration”</span></p>
<p class="p5"><span class="sz"><span class="s1"></span> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?3fb24c08